// Fills %{name} placeholders in a server-supplied label.
// Labels arrive from Ehc::MonitoringHelper with their placeholders intact so that
// interpolation happens where the numbers live, without a client-side i18n library.
export function fill(template, values) {
  if (!template) return '';
  if (!values) return template;

  return Object.keys(values).reduce(function (text, key) {
    return text.split('%{' + key + '}').join(String(values[key]));
  }, template);
}

export function percentage(part, total) {
  if (!total) return 0;
  return Math.round((part * 100) / total);
}

export function signed(value) {
  return value > 0 ? '+' : '';
}

export function initials(name) {
  if (!name) return '—';
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map(function (word) { return word.charAt(0).toUpperCase(); })
    .join('');
}

export function hourLabelFrom(hourLabel) {
  return hourLabel || '';
}

// Participant matches the free-text search across name, employee ID and company.
export function matchesQuery(participant, query) {
  if (!query) return true;
  var needle = query.toLowerCase();

  return ['name', 'employee_id', 'company'].some(function (field) {
    return String(participant[field] || '').toLowerCase().indexOf(needle) !== -1;
  });
}
